import type { ApprovalBarProps } from "@/components/assistant/useAssistantWriteApprovalHandlers";
import { createContext, useContext, type ReactNode } from "react";

export type SupervisorPendingApproval = {
  toolCallId: string;
  runId: string;
  toolName: string;
  mode: "create" | "update";
  proposal: Record<string, unknown>;
  approvalReady: boolean;
};

type SupervisorApprovalValue = {
  busy: boolean;
  activePending: SupervisorPendingApproval | null;
  pendingDockActions: ApprovalBarProps | null;
  approveEdited: (toolCallId: string, proposal: Record<string, unknown>) => void;
  routeLabel: string | null;
};

const SupervisorApprovalContext = createContext<SupervisorApprovalValue | null>(null);

export function SupervisorApprovalProvider({
  value,
  children,
}: {
  value: SupervisorApprovalValue;
  children: ReactNode;
}) {
  return (
    <SupervisorApprovalContext.Provider value={value}>{children}</SupervisorApprovalContext.Provider>
  );
}

export function useSupervisorApproval(): SupervisorApprovalValue {
  const value = useContext(SupervisorApprovalContext);
  if (!value) {
    throw new Error("useSupervisorApproval must be used within SupervisorApprovalProvider");
  }
  return value;
}
